import styled from "styled-components";

export const Wrapper = styled.div`
  border-radius: 12px;
  width: 100%;
  height: 0;
  overflow: hidden;
  animation: 250ms slide-out linear;

  overscroll-behavior: contain;
  -webkit-overflow-scrolling: auto;
  touch-action: pan-x pan-y;

  &.show {
    height: 300px;
    margin-top: 24px;
    display: unset;
    animation: 250ms slide-in linear;
  }

  @keyframes slide-in {
    from {
      height: 0;
    }
    to {
      height: 300px;
    }
  }

  @keyframes slide-out {
    from {
      height: 300px;
    }
    to {
      height: 0;
    }
  }
`;
